import { Checkbox, Icon, Select, Text } from "@shopify/polaris";
import { ClockIcon } from "@shopify/polaris-icons";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const frequencyOptions = [
  { label: "Every 15 minutes", value: "15" },
  { label: "Every 30 minutes", value: "30" },
  { label: "Every hour", value: "60" },
  { label: "Every 6 hours", value: "360" },
  { label: "Every 12 hours", value: "720" },
  { label: "Every day", value: "1440" },
];

const ScheduledSyncSettings = () => {
  const { search } = useLocation();
  const shop = new URLSearchParams(search).get("shop");
  const [enabled, setEnabled] = useState(true);
  const [frequencyMinutes, setFrequencyMinutes] = useState("30");
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/shopify/store/settings?shop=${shop}`,
    )
      .then((response) => response.json())
      .then((result) => {
        const settings = result.data?.syncSettings || {};
        setEnabled(settings.enabled !== false);
        setFrequencyMinutes(String(settings.frequencyMinutes || 30));
      })
      .catch(() => setMessage("Unable to load scheduled sync settings."));
  }, [shop]);

  const save = async (
    nextEnabled = enabled,
    nextFrequency = frequencyMinutes,
  ) => {
    setEnabled(nextEnabled);
    setFrequencyMinutes(nextFrequency);
    setMessage("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/shopify/store/update_settings?shop=${shop}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            settings: {
              syncSettings: {
                enabled: nextEnabled,
                frequencyMinutes: Number(nextFrequency),
              },
            },
          }),
        },
      );
      if (!response.ok) throw new Error("Save failed");
      setMessage("Saved.");
    } catch (error) {
      setMessage("Unable to save scheduled sync settings.");
    }
  };

  return (
    <div className="settings-card">
      <div className="settings-card__header">
        <span className="app-icon-tile">
          <Icon source={ClockIcon} tone="base" />
        </span>
        <div>
          <h3>Scheduled Sync</h3>
          <p>Keep the Google catalog updated on a timer.</p>
        </div>
      </div>

      <div className="settings-field">
        <div className="settings-field__label">Automatic sync</div>
        <div className="settings-field__control">
          <Checkbox
            label="Automatically sync products"
            checked={enabled}
            onChange={(value) => save(value, frequencyMinutes)}
          />
        </div>
      </div>

      <div className="settings-field">
        <div className="settings-field__label">Frequency</div>
        <div className="settings-field__control" style={{ width: "100%" }}>
          <div style={{ width: "100%" }}>
            <Select
              label="Frequency"
              labelHidden
              options={frequencyOptions}
              value={frequencyMinutes}
              disabled={!enabled}
              onChange={(value) => save(enabled, value)}
            />
          </div>
        </div>
      </div>

      {message ? (
        <Text tone="subdued" as="p">
          {message}
        </Text>
      ) : null}
    </div>
  );
};

export default ScheduledSyncSettings;
